export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '311e8b06-db8d-4482-88e0-cc1375ff5cf3';
export const MODAL_CLOSE_SEC = 2.5;
